import {dateFilterParams} from '../../views/components/ag-grid/filter-params/DateComparator';

export default [
  {
    headerName: 'DateOfSubmission',
    headerClass: 'header-text-wrap',
    field: 'DateOfSubmission',
    tooltipField: 'DateOfSubmission',
    tooltipComponentParams: { field: 'DateOfSubmission' },
    filter: 'agDateColumnFilter',
    minWidth: 140,
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
    sort: 'desc',
  },
  {
    headerName: 'Distributor',
    headerClass: 'header-text-wrap',
    field: 'Distributor',
    tooltipField: 'Distributor',
    tooltipComponentParams: { field: 'Distributor' },
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'Quote',
    tooltipField: 'Quote',
    tooltipComponentParams: { field: 'QuoteURL' },
    cellRenderer: 'CellRendererButton',
    cellClass: 'flex justify-start',
    minWidth: 81,
    maxWidth: 81,
    cellRendererParams(params) {
      return {
        buttonTxt: 'Quote',
        column: 'QuoteURL',
        backGroundColour: params.data.BtnBkGround,
        borderColour: params.data.BtnBorder,
        fontColour: params.data.BtnFontClr,
      }
    },
  },
  {
    headerName: 'QuoteNumber',
    headerClass: 'header-text-wrap',
    field: 'QuoteNumber',
    tooltipField: 'QuoteNumber',
    tooltipComponentParams: { field: 'QuoteNumber' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'InsuredName',
    headerClass: 'header-text-wrap',
    field: 'InsuredName',
    tooltipField: 'InsuredName',
    tooltipComponentParams: { field: 'InsuredName' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'InsuredSurname',
    headerClass: 'header-text-wrap',
    field: 'InsuredSurname',
    tooltipField: 'InsuredSurname',
    tooltipComponentParams: { field: 'InsuredSurname' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'InsuredCompanyName',
    headerClass: 'header-text-wrap',
    field: 'InsuredCompanyName',
    tooltipField: 'InsuredCompanyName',
    tooltipComponentParams: { field: 'InsuredCompanyName' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'FiscalCode',
    headerClass: 'header-text-wrap',
    field: 'FiscalCode',
    tooltipField: 'FiscalCode',
    tooltipComponentParams: { field: 'FiscalCode' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'VATCode',
    headerClass: 'header-text-wrap',
    field: 'VATCode',
    tooltipField: 'VATCode',
    tooltipComponentParams: { field: 'VATCode' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'Premium',
    headerClass: 'header-text-wrap',
    field: 'Premium',
    tooltipField: 'Premium',
    tooltipComponentParams: {
      field: 'Premium',
      showCurrency: true,
    },
    filter: 'agTextColumnFilter',
    cellRenderer: 'CellRendererMasterValue',
    cellRendererParams(params) {
      return {
        unit: '€',
        unitPosition: 'start',
        returnFloat: true,
      }
    },
  },
  {
    headerName: 'ORARaterName',
    headerClass: 'header-text-wrap',
    field: 'ORARaterName',
    tooltipField: 'ORARaterName',
    tooltipComponentParams: { field: 'ORARaterName' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'CompanyProducerCode',
    headerClass: 'header-text-wrap',
    field: 'CompanyProducerCode',
    tooltipField: 'CompanyProducerCode',
    tooltipComponentParams: { field: 'CompanyProducerCode' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'CompanyProducerName',
    headerClass: 'header-text-wrap',
    field: 'CompanyProducerName',
    tooltipField: 'CompanyProducerName',
    tooltipComponentParams: { field: 'CompanyProducerName' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'User',
    headerClass: 'header-text-wrap',
    field: 'SubmitterName',
    tooltipField: 'SubmitterName',
    tooltipComponentParams: { field: 'SubmitterName' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'LastModifiedDateTime',
    headerClass: 'header-text-wrap',
    field: 'LastModifiedDateTime',
    tooltipField: 'LastModifiedDateTime',
    tooltipComponentParams: { field: 'LastModifiedDateTime', isDate: true },
    filter: 'agDateColumnFilter',
    minWidth: 100,
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
  },
];

